import {
  buildHtml,
  buildLink,
  ContentRoute,
  RouteSlotInput,
} from '@caritas/ui';

import { isProject } from '../../utils/is-project';
import { mapImage } from '../Image.mappers';
import { hasImage } from './ContentPageHeader.mappers';

export function mapTeaserList(
  input: BlockTeaserListFragment & { Title?: string },
):
  | RouteSlotInput<typeof ContentRoute, 'body', 'teaserGrid'>
  | RouteSlotInput<typeof ContentRoute, 'body', 'teaserSlideshow'> {
  return {
    key: input.layout === 'carousel' ? 'teaserSlideshow' : 'teaserGrid',
    input: () => [
      {
        Title: input.Title ? buildHtml(input.Title) : undefined,
        teasers:
          input.teasers
            // Filter out potential nulls first
            ?.filter((teaser) => teaser !== null)
            .map((item) => {
              // We know this won't be null, so force typing here
              const teaser = item as unknown as Teaser;
              const image = hasImage(teaser.image)
                ? mapImage({
                    image: teaser.image.image,
                    preset: 'teaser',
                    sizes: '(max-width: 1023px) 900px, 300px',
                    caption: teaser.image.caption,
                  })
                : undefined;
              return {
                title: teaser.title,
                language: teaser.language,
                Link: buildLink({ href: teaser.url }),
                Image: image,
                description:
                  input.showDescriptions !== false
                    ? item?.description
                    : undefined,
                isProject: isProject(teaser.format),
              };
            }) || [],
      },
      200,
    ],
  };
}
